export function downloadPayslipPdf({
  fileName,
  pdfBase64,
}: {
  fileName: string;
  pdfBase64: string;
}) {
  const bytes = Uint8Array.from(atob(pdfBase64), (character) =>
    character.charCodeAt(0),
  );
  const url = URL.createObjectURL(
    new Blob([bytes], { type: "application/pdf" }),
  );
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
